import { useState } from "react";
import { chatContext, ChatStrategyType } from "@services/chat/ChatContext";
import style from "./style.module.scss";

interface StrategySelectorProps {
  onStrategyChange?: (strategyType: ChatStrategyType) => void;
}

export const StrategySelector = ({
  onStrategyChange,
}: StrategySelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentStrategy, setCurrentStrategy] =
    useState<ChatStrategyType>("simplified");

  const strategies = chatContext.getAvailableStrategies();

  const handleStrategyChange = (strategyType: ChatStrategyType) => {
    chatContext.setStrategy(strategyType);
    setCurrentStrategy(strategyType);
    setIsOpen(false);
    onStrategyChange?.(strategyType);
  };

  const currentStrategyInfo = strategies.find(
    (s) => s.type === currentStrategy,
  );

  return (
    <div className={style.strategySelector}>
      <button
        type="button"
        className={style.strategySelector__toggle}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={style.strategySelector__current}>
          {currentStrategyInfo?.name || "Select Strategy"}
        </span>
        <span className={style.strategySelector__arrow}>
          {isOpen ? "▲" : "▼"}
        </span>
      </button>

      {isOpen && (
        <div className={style.strategySelector__dropdown}>
          {strategies.map((strategy) => (
            <button
              key={strategy.type}
              type="button"
              className={`
                ${style.strategySelector__option}
                ${strategy.type === currentStrategy ? style._active : ""}
              `}
              onClick={() => handleStrategyChange(strategy.type)}
            >
              <div className={style.strategySelector__name}>
                {strategy.name}
              </div>
              <div className={style.strategySelector__description}>
                {strategy.description}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
